<template>
  <air-verification-code
    :placeholder="placeholder"
    :size="size"
    :maxLength="maxLength"
    :actionText="actionText"
    :sendCode="onSendCode"
    :handlerErrorBySelf="handlerErrorBySelf"
    @change="onChange"
  >
  </air-verification-code>
</template>

<script>
import { fetchMobileCode, fetchEmailCode } from '@/api/verify'
import eventBus from '../eventBus.js'
export default {
  name: 'user-verification-code',
  props: {
    type: {
      type: String,
      default: 'phone'
    },
    /**
     * 验证码字符长度
     */
    maxLength: {
      type: Number,
      default: 6
    },
    /**
     * 间隔时间
     */
    timeout: {
      type: Number,
      default: 60
    },
    /**
     * 输入框大小
     * @values default, small, large
     */
    size: {
      type: String,
      default: 'default'
    },
    /**
     * 输入框提示
     */
    placeholder: {
      type: String,
      default: '请输入动态码'
    },
    /**
     * 按钮默认文字
     */
    actionText: {
      type: String,
      default: '点击发送验证码'
    },
    /**
     * 手机号|邮箱
     */
    value: {
      type: String
    },
    /**
     * 验证码类型
     */
    smsType: {
      type: Number
    },
    areaCode: {
      type: String,
      default: ''
    },
    token: {
      type: String
    },
    handlerErrorBySelf: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onSendCode () {
      return new Promise((resolve, reject) => {
        // 延迟以获取到手机和验证码的值
        setTimeout(async () => {
          const { value, type, smsType, areaCode, token } = this
          if (!token) {
            const err = new Error('请先完成滑块验证！')
            this.$emit('error', err)
            return reject(err)
          }

          if (!value) {
            const err = new Error(`请先输入${type === 'phone' ? '手机' : '邮箱'}号码！`)
            this.$emit('error', err)
            return reject(err)
          }

          try {
            if (type === 'phone') {
              const data = await fetchMobileCode({
                mobile: value,
                token,
                smsType,
                areaCode
              }).then(res => {
                eventBus.$emit('get-token', res.token)
                // window.localStorage.setItem('register-token', res.token)
              })
              resolve(data)
            } else {
              const data = await fetchEmailCode({
                receiverEmail: value,
                token,
                smsType
              }).then(res => {
                eventBus.$emit('get-token', res.token)
                // window.localStorage.setItem('register-token', res.token)
              })
              resolve(data)
            }
          } catch (err) {
            // TODO: 50005的处理
            this.$emit('error', err)
            eventBus.$emit('on-refresh')
            return reject(err)
          }
        }, 300)
      })
    },
    onChange (e) {
      this.$emit('change', e.target.value)
    }
  }
}
</script>
